import { FieldStatusEnum, ValidateFunction, isInvalidValue } from '@inv/hooks'
import { ValidateOptionsExtra } from '../../models/ElementModel/typing'
import { transifyOptions } from '../../../utils/transify'

export const validateFeedbackDescription: ValidateFunction<ValidateOptionsExtra> = ({ value }) => {
  const { i18n } = transifyOptions
  if (!isInvalidValue(value)) {
    if (value.length < 10 || value.length > 500) {
      return {
        status: FieldStatusEnum.Invalid,
        content: i18n.t('invest.user_feedback.form.desc_error')
      }
    } else {
      return {
        status: FieldStatusEnum.Success
      }
    }
  }

  return {
    status: FieldStatusEnum.UnCheck
  }
}
